export default __webpack_public_path__ + "static/media/7.c432e840.jpg";